import React from 'react';

interface SliderProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  /** Optional formatted readout shown to the right (e.g. "75%", "180°") */
  valueLabel?: string;
}

// Plain `<input type="range">` renders with the browser's stock styling, which
// looks dated next to the rest of this app's flat/rounded UI. This wraps the
// same native input (keeps full keyboard/accessibility behavior) but paints
// the track as a filled progress bar up to the thumb, with a larger custom
// thumb — purely visual, the value/onChange contract is unchanged.
export function Slider({ value, min, max, step = 1, onChange, valueLabel }: SliderProps) {
  const pct = ((value - min) / (max - min || 1)) * 100;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
        className="byi-slider"
        style={{
          flex: 1,
          ['--byi-slider-pct' as any]: `${pct}%`,
        }}
      />
      {valueLabel != null && (
        <span style={{ fontSize: 11, color: 'var(--text-muted)', width: 34, textAlign: 'right', flexShrink: 0 }}>
          {valueLabel}
        </span>
      )}
    </div>
  );
}
